import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, from, of, switchMap } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const oidcService = inject(OidcSecurityService);

    const isCognito =
        req.url.includes(
            'https://dev-snc-user-pool-domain.auth.us-east-1.amazoncognito.com'
        ) ||
        req.url.includes('https://auth.formacionacademica.fmf.mx') ||
        req.url.includes(
            'https://dev-snf-user-pool-domain.auth.us-east-1.amazoncognito.com'
        ) ||
        req.url.includes(
            'https://prd-snf-user-pool-domain.auth.us-east-1.amazoncognito.com'
        );
    if (isCognito) {
        return next(req);
    }

    // Obtén el ID Token desde el servicio de autenticación. El catchError
    // cubre solo la lectura del token: si envolviera también next(), un error
    // HTTP del API reenviaría la petición (p. ej. un segundo POST de sign-up
    // con el token de reCAPTCHA ya usado).
    return from(oidcService.getIdToken()).pipe(
        catchError((error) => {
            console.warn('Error en auth interceptor:', error);
            // Si no hay token, continúa sin autorización
            return of(null);
        }),
        switchMap((idToken) =>
            next(
                idToken
                    ? req.clone({ setHeaders: { Authorization: `${idToken}` } })
                    : req
            )
        )
    );
};
